import { Link } from "react-router-dom";
import type { AnimeNews } from "@/types/anime";

export default function RelatedNewsList({ items, currentId }: { items: AnimeNews[]; currentId?: string }) {
  const list = items.filter((item) => item.id !== currentId).slice(0, 5);
  if (list.length === 0) return null;

  return (
    <ul className="flex flex-col gap-3">
      {list.map((item) => (
        <li key={item.id}>
          <Link
            to={`/news/detail/${item.id}`}
            className="group flex gap-3 rounded-lg p-2 transition-colors hover:bg-background-100 cursor-pointer"
          >
            <span className="h-16 w-24 shrink-0 overflow-hidden rounded-md bg-background-100">
              <img
                src={item.cover}
                alt={`${item.title} 缩略图`}
                title={`${item.title} - 78动漫资讯`}
                className="h-full w-full object-cover object-top"
              />
            </span>
            <span className="flex flex-1 flex-col justify-center">
              <span className="line-clamp-2 text-sm font-medium leading-snug text-foreground-900 transition-colors group-hover:text-primary-600">
                {item.title}
              </span>
              <span className="mt-1 text-xs text-foreground-400">{item.dateLabel}</span>
            </span>
          </Link>
        </li>
      ))}
    </ul>
  );
}